
import { Mixins, Component } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import ETable from "@/components/ETable.vue";
import loading from "@/mixins/loading";
import EditDialog from "./components/editDialog.vue";

@Component({ name: 'ai-evaluation-weight-index',
  components: { ETable, EditDialog }
})
export default class AiEvaluationWeight extends Mixins(loading, tablePagination) {
  queryForm = {
    tongueConstitution: "",
    bodyFatType: ""
  };

  itemTotal = 0;
  tableData = [];
  id = "";
  EditDialogVisible = false;

  tongueConstitutionOptions = [
    { label: "平和质", value: "平和质" },
    { label: "气虚质", value: "气虚质" },
    { label: "阳虚质", value: "阳虚质" },
    { label: "阴虚质", value: "阴虚质" },
    { label: "痰湿质", value: "痰湿质" },
    { label: "湿热质", value: "湿热质" },
    { label: "血瘀质", value: "血瘀质" },
    { label: "气郁质", value: "气郁质" },
    { label: "特禀质", value: "特禀质" }
  ];

  bodyFatTypeOptions = [
    { label: "偏瘦型", value: "偏瘦型" },
    { label: "标准型", value: "标准型" },
    { label: "偏胖型", value: "偏胖型" },
    { label: "肥胖型", value: "肥胖型" }
  ];

  columns = [
    { label: "ID", prop: "id", width: "80px" },
    { label: "舌诊体质", prop: "tongueConstitution" },
    { label: "体脂体型", prop: "bodyFatType" },
    { label: "症状", prop: "symptom" },
    { label: "原因", prop: "reason" },
    { label: "预防疾病", prop: "preventDisease" },
    { label: "操作人", prop: "operator" },
    { label: "最后操作时间", prop: "updateTime", width: "160px" },
    { label: "操作", prop: "action", width: "150px" }
  ];

  mounted() {
    this.getData();
  }

  searchData() {
    this.resetCurrent();
    this.getData();
  }

  getData() {
    // TODO: 调用接口获取数据
    // const params = {
    //   ...this.queryForm,
    //   pageNum: this.currentPage,
    //   pageSize: this.pageSize,
    // };
    // this.showLoading();
    // getAiEvaluationWeightList(params).then((res) => {
    //   this.tableData = res.data.list;
    //   this.itemTotal = res.data.total;
    // });
  }

  handleEdit(row: any) {
    this.id = row.id;
    this.EditDialogVisible = true;
  }

  editConfirm() {
    this.getData();
    this.EditDialogVisible = false;
  }
}
